export default "__VITE_ASSET__DCKJurg6__"